import React from "react";
import firebase from "firebase";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import Dropzone from "react-dropzone";
import ImageCompressor from "image-compressor.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import Img from "react-image";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Layout from "../layouts/Layout";
import { primaryShade1, white } from "../styles/color";

const styles = {
  bigAvatar: {
    height: "100px",
    width: "100px",
    margin: 15
  }
};
class AddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      imageURL: "",
      phoneNumber: "",
      address: ""
    };
  }
  componentWillMount() {
    const image = firebase
      .storage()
      .ref()
      .child("images");
    this.setState({ image });
  }
  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  onDrop = (acceptedFiles, rejectedFiles) => {
    const file = acceptedFiles[0];
    if (file == null) {
      alert("Invalid File Type!");
    } else {
      this.setState({ completed1: true });
    }
    new ImageCompressor(file, {
      quality: 0.55,
      maxWidth: 1500,
      success: result => {
        const ref = this.state.image.child(new Date().toString());
        ref.put(file).then(() => {
          ref.getDownloadURL().then(url => {
            this.setState({
              completed: true,
              imageURL: url
            });
          });
        });
      }
    });
  };

  render() {
    const { addCustomer } = this.props;
    const { name, email, phoneNumber, imageURL } = this.state;
    return (
      <Layout position="static" appBar appBarTitle={"ADD PRODUCT"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItem: "center",
            margin: "10px",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
            onClick={this.onDrop}
          >
            <Avatar style={styles.bigAvatar}>
              <Dropzone
                onDrop={this.onDrop}
                accept="image/*"
                style={{
                  width: "100px",
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%"
                }}
              >
                {({ getRootProps, getInputProps, isDragActive }) => {
                  return (
                    <div>
                      <Img
                        src={imageURL ? imageURL : "Add DP"}
                        alt=""
                        style={{
                          objectFit: "cover",
                          height: "100%",
                          width: "100%"
                        }}
                        loder={<CircularProgress />}
                      />
                    </div>
                  );
                }}
              </Dropzone>
            </Avatar>
          </div>

          <span>Name</span>
          <TextField
            id="outlined-bare"
            type="text"
            placeholder="name"
            value={name}
            onChange={this.handleChange("name")}
            margin="normal"
            variant="outlined"
          />
          <span>PhoneNumber</span>
          <TextField
            id="outlined-bare"
            name="phoneNumber"
            placeholder="9876543210"
            type="number"
            onChange={this.handleChange("phoneNumber")}
            value={phoneNumber}
            margin="normal"
            variant="outlined"
          />
          <span>Email</span>
          <TextField
            id="outlined-bare"
            name="email"
            placeholder="xyz@example.com"
            type="email"
            onChange={this.handleChange("email")}
            value={email}
            margin="normal"
            variant="outlined"
          />
          <span>Address</span>
          <TextField
            id="outlined-bare"
            name="address"
            placeholder="address"
            multiline
            rowsMax="4"
            onChange={this.handleChange("address")}
            margin="normal"
            variant="outlined"
          />
          <Button
            variant="contained"
            color={primaryShade1}
            onClick={e => {
              e.preventDefault();
              const customer = {
                name: this.state.name,
                email: this.state.email,
                imageURL: this.state.imageURL,
                phoneNumber: this.state.phoneNumber,
                address: this.state.address,
                userId: this.props.user.uid,
                createdAt: new Date()
              };
              addCustomer(customer);
              this.props.history.goBack();
            }}
            style={{
              position: "fixed",
              bottom: "10px",
              backgroundColor: primaryShade1,
              color: white,
              width: "94%"
            }}
          >
            ADD
          </Button>
        </div>
      </Layout>
    );
  }
}

export default withRouter(withUser(AddCustomer));
